import { render, staticRenderFns } from "./DeadsMassivelyChicksCA.vue?vue&type=template&id=363c7896&scoped=true"
import script from "./DeadsMassivelyChicksCA.vue?vue&type=script&lang=js"
export * from "./DeadsMassivelyChicksCA.vue?vue&type=script&lang=js"
import style0 from "./DeadsMassivelyChicksCA.vue?vue&type=style&index=0&id=363c7896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363c7896",
  null
  
)

export default component.exports